export default {
  stripe_session: (state) => {
    return state.stripe_session;
  },
  checkout_link: (state) => {
    return state.checkout_link;
  },
};
